import "./styles.scss";
import { SearchListings } from "../../js/search-listings";

new SearchListings();
